import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
export let MarketplaceProductOptionType = /*#__PURE__*/function (MarketplaceProductOptionType) {
  MarketplaceProductOptionType["DROPDOWN"] = "DROPDOWN";
  return MarketplaceProductOptionType;
}({});
export let StockLevel = /*#__PURE__*/function (StockLevel) {
  StockLevel["IN_STOCK"] = "IN_STOCK";
  StockLevel["LOW_STOCK"] = "LOW_STOCK";
  StockLevel["UNAVAILABLE"] = "UNAVAILABLE";
  return StockLevel;
}({});
export let IssueType = /*#__PURE__*/function (IssueType) {
  IssueType["OutOfStock"] = "OUT_OF_STOCK";
  IssueType["LowStock"] = "LOW_STOCK";
  IssueType["NotEnoughStock"] = "NOT_ENOUGH_STOCK";
  return IssueType;
}({});
export let IssueSeverity = /*#__PURE__*/function (IssueSeverity) {
  IssueSeverity["Warning"] = "WARNING";
  IssueSeverity["Error"] = "ERROR";
  return IssueSeverity;
}({});
export class MarketplaceProduct {
  constructor(marketplaceProduct, marketplaceShop) {
    var _marketplaceShop$reta, _marketplaceShop$reta2, _marketplaceShop$reta3, _marketplaceShop$reta4;
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "shop", void 0);
    _defineProperty(this, "brand", void 0);
    _defineProperty(this, "category", void 0);
    _defineProperty(this, "description", void 0);
    _defineProperty(this, "careInstructions", void 0);
    _defineProperty(this, "warnings", void 0);
    _defineProperty(this, "warranty", void 0);
    _defineProperty(this, "variants", void 0);
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "modifiers", void 0);
    _defineProperty(this, "toProductOptions", options => (options === null || options === void 0 ? void 0 : options.filter(o => o !== null)) || []);
    this.id = marketplaceProduct.id;
    this.title = marketplaceProduct.title;
    this.shop = {
      retailerId: (_marketplaceShop$reta = marketplaceShop.retailer) === null || _marketplaceShop$reta === void 0 ? void 0 : _marketplaceShop$reta.sys.id,
      id: marketplaceShop.id,
      name: (_marketplaceShop$reta2 = (_marketplaceShop$reta3 = marketplaceShop.retailer) === null || _marketplaceShop$reta3 === void 0 ? void 0 : _marketplaceShop$reta3.title) !== null && _marketplaceShop$reta2 !== void 0 ? _marketplaceShop$reta2 : marketplaceShop.name,
      logoUrl: (_marketplaceShop$reta4 = marketplaceShop.retailer) === null || _marketplaceShop$reta4 === void 0 || (_marketplaceShop$reta4 = _marketplaceShop$reta4.retailerLogoSet) === null || _marketplaceShop$reta4 === void 0 || (_marketplaceShop$reta4 = _marketplaceShop$reta4.coloured) === null || _marketplaceShop$reta4 === void 0 ? void 0 : _marketplaceShop$reta4.url
    };
    this.brand = marketplaceProduct.brand;
    this.category = marketplaceProduct.category;
    this.description = marketplaceProduct.description;
    this.careInstructions = marketplaceProduct.careInstructions;
    this.warnings = marketplaceProduct.warnings;
    this.warranty = marketplaceProduct.warranty;
    this.variants = marketplaceProduct.variants;
    // TODO: implement options & modifiers
    // or remove current use of these attributes
    this.options = this.toProductOptions(marketplaceProduct.options);
    this.modifiers = [];
  }
}